import {prepareUpsellData} from '@optimaxdev/analytics/desktop/lib/ecommerce/helpers/index';
import {pushDataLayer} from '@optimaxdev/analytics/desktop/lib/pushDataLayer/index';
import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import {CHECKOUT_PAYMENT_STEP} from 'constants/analytics/events/checkout';

import {
    AccessoryType,
    AccessoryWindowType,
} from 'desktop/pages/cart/store/reducers/accessories/accessoriesType';
import {logWithSentryEEC} from 'libs/sentry/sentry';

/**
 * Send analytic when click on amazon button auth
 */
export function sendAnalyticsAmazonAuthButton() {
    sendDesktopAnalyticsEvent(CHECKOUT_PAYMENT_STEP, {
        message: 'CTA - Amazon pay',
        method: 'Payment',
    });
}

/**
 * Sends a list of viewed accessories to the analytic
 * @param {AccessoryType} accessoryItem - accessory item
 * @param {AccessoryWindowType[]} accessories - needed to take a position from rendered list
 */
export const sendAnalyticsForAccessoriesFromCart = (
    accessoryItem: AccessoryType[],
    accessories: AccessoryWindowType[],
    accessoriesType: string,
) => {
    const impressions = accessoryItem.map(accessory => {
        const accessoryItemWithType = {...accessory, type: 'accessory'};
        const accessoryIndex = accessories.findIndex(({id}) => id === accessory.parentId);
        const accessoryPosition = accessoryIndex + 1;

        return {
            ...prepareUpsellData(accessoryItemWithType, accessory.sku),
            dimension74: accessoryPosition,
        };
    });
    const event = {
        ecommerce: {
            impressions,
        },
        event: accessoriesType,
    };
    pushDataLayer(event);

    logWithSentryEEC(accessoriesType, event);
};
